import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PhosphorIcon from './PhosphorIcon';
import ClayIcon from '../v2/ClayIcon';
import { contact, whatsappLink } from '../../content/siteContent';

/**
 * Floating glass dock — WhatsApp | Call | Book a demo — for phones only.
 * Slides away while scrolling down (so it never covers what you're reading) and returns on scroll up.
 */
export default function MobileActionBar() {
  const [hidden, setHidden] = useState(false);
  const { pathname } = useLocation();
  const onContactPage = pathname === '/contact-us';

  useEffect(() => {
    let lastY = window.scrollY;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const y = window.scrollY;
        const nearBottom = window.innerHeight + y > document.documentElement.scrollHeight - 120;
        if (Math.abs(y - lastY) > 6) {
          setHidden(y > lastY && y > 240 && !nearBottom);
          lastY = y;
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <nav aria-label="Quick contact" className={`m-dock md:hidden${hidden ? ' is-hidden' : ''}`}>
      <div className="m-dock-inner glass">
        <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="m-dock-item">
          <ClayIcon
            name="WhatsappLogo"
            size={30}
            fallback={<PhosphorIcon name="WhatsappLogo" size={22} weight="fill" style={{ color: '#138A57' }} />}
          />
          <span>WhatsApp</span>
        </a>
        <a href={`tel:${contact.phoneRaw}`} className="m-dock-item">
          <ClayIcon
            name="Phone"
            size={30}
            fallback={<PhosphorIcon name="Phone" size={22} weight="fill" style={{ color: 'var(--accent)' }} />}
          />
          <span>Call</span>
        </a>
        {onContactPage ? (
          <a href="#contact" className="m-dock-cta clay-soft">
            Send request
            <PhosphorIcon name="ArrowRight" size={16} weight="bold" />
          </a>
        ) : (
          <Link to="/contact-us" className="m-dock-cta clay-soft">
            Book a demo
            <PhosphorIcon name="ArrowRight" size={16} weight="bold" />
          </Link>
        )}
      </div>
    </nav>
  );
}
